import { SECONDS_TO_DAYS_MULTIPLIER } from '@common/constants/general/date-time';

// Функция, которая возвращает прошедшее время со старта движения в секундах
export const timeFromStart = (timeStart: number | null, timeShift: number) => {
  return (timeStart || 0) + timeShift * SECONDS_TO_DAYS_MULTIPLIER;
};
